/* =========================================================
   HERBESSA CUSTOM JS
   Update-safe custom scripts
   ========================================================= */

(function () {
  function initBackToTop() {
    var button = document.querySelector('.hb-back-to-top');

    if (!button || button.dataset.hbBackToTopReady === 'true') return;

    button.dataset.hbBackToTopReady = 'true';

    var showAfter = 520;

    function updateBackToTop() {
      button.classList.toggle('is-visible', window.scrollY > showAfter);
    }

    window.addEventListener('scroll', updateBackToTop, {
      passive: true
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    updateBackToTop();
  }

  
  

  function initHerbessaCustom() {
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHerbessaCustom);
  } else {
    initHerbessaCustom();
  }

  document.addEventListener('shopify:section:load', initHerbessaCustom);
})();
